import React, { Component } from 'react';
import OpenOrders from './openOrders';

class Home extends Component {

  render() {
    return (
    <div className='home'>
      <h3>{JSON.parse(localStorage.getItem('token')).groupname}: Open Orders</h3>
      <p>User: {JSON.parse(localStorage.getItem('token')).username}</p>
      <OpenOrders />
      {/* <API /> */}
    </div>
    );
  }
}

export default Home;